import { FloatLabel } from "primereact/floatlabel";
import { Calendar } from "primereact/calendar";

import commonStyle from "../../content/CommonStyles.module.css";

const CalendarInput = ({ formik, paramName, label, isDisabled, isMobile }) => {

    const field = formik.getFieldProps(paramName);

    return (
        <div className={`${commonStyle.formInput} ${!isMobile ? "" : "w-11"}`}>
            <div className="p-inputgroup flex-1">
                <FloatLabel>
                    <Calendar value={field.value}
                        onChange={(e) => { formik.setFieldValue(paramName, e.target.value) }}
                        dateFormat="dd/mm/yy"
                        disabled={isDisabled}
                        showIcon />
                    <label>{label}</label>
                </FloatLabel>
            </div>
        </div>
    );
}

export default CalendarInput;